import { useEffect, useState } from "react";

export function useTooltipText(ref: any, label: string) {
    const [tooltipText, setTooltipText] = useState<string>("");

    useEffect(() => {
        if (!ref.current) {
            return undefined;
        }

        const observer = new ResizeObserver((el) => {
            const targetedElement = el[0].target as HTMLParagraphElement | undefined;

            if (
                targetedElement &&
                (targetedElement?.offsetHeight < targetedElement.scrollHeight || targetedElement?.offsetWidth < targetedElement.scrollWidth)
            ) {
                setTooltipText(label);
            } else {
                setTooltipText("");
            }
        });

        observer.observe(ref.current, { box: "border-box" });

        return () => observer.disconnect();
    }, [label, ref.current]);

    return tooltipText;
}
